var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_206_16716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.44442 14.8146H2.44194C1.68773 14.785 0.985806 14.4294 0.522831 13.8294C0.0673241 13.2368 -0.104424 12.4739 0.0673241 11.7405L0.24654 10.8961C0.455625 9.75534 1.44131 8.91089 2.61368 8.88867H6.1756C5.3766 9.57756 4.86882 10.5998 4.86882 11.7405C4.86882 12.9998 5.48861 14.1183 6.44442 14.8146Z",
    fill: "#83888E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.28054 7.40741H5.53381C3.88353 7.40741 2.54688 6.08148 2.54688 4.44444V2.48889C2.54688 1.82963 2.80823 1.19259 3.27867 0.725926C3.74911 0.259259 4.39131 0 5.0559 0H6.75845C7.42304 0 8.06523 0.259259 8.53567 0.725926C9.00612 1.19259 9.26747 1.82963 9.26747 2.48889V4.44444C9.26747 5.22963 8.95384 5.98519 8.39379 6.54074C7.83374 7.0963 7.07208 7.40741 6.28054 7.40741Z",
    fill: "#83888E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0377 9.437C10.4179 8.82219 9.58899 8.48145 8.71531 8.48145C6.90075 8.48145 5.42969 9.9407 5.42969 11.7407C5.42969 13.5407 6.90075 15 8.71531 15C10.5299 15 12.0009 13.5407 12.0009 11.7407C12.0009 10.8666 11.6574 10.0518 11.0377 9.437ZM8.71531 14.1703C8.25981 14.1703 7.8043 14.037 7.42346 13.8L10.7912 10.4592C11.2393 11.1703 11.2915 12.0592 10.9032 12.8296C10.4851 13.6518 9.64873 14.1703 8.71531 14.1703ZM6.26603 11.7407C6.26603 10.7703 6.84101 9.89626 7.72963 9.51108C8.04325 9.37774 8.37928 9.31107 8.70785 9.31107C9.25296 9.31107 9.79061 9.48885 10.2237 9.837L6.78874 13.2444C6.45271 12.8222 6.26603 12.2889 6.26603 11.7407Z",
    fill: "#83888E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_206_16716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockImg);
export default __webpack_public_path__ + "static/media/blockImg.16d2859bb9efbbdfc7d7c0d9350e7645.svg";
export { ForwardRef as ReactComponent };